/**
 * @desc 财务画像-基础信息-报表异常提示
 */
import React, { PureComponent } from 'react';
import GroupBox from '../../../common/groupBox/GroupBox';
import style from '../common/assetLiabilities.scss';
import NoData from '../../../common/noData/NoData';
import NormalReportTip from '../../../common/normalReportTip/NormalReportTip';
import CommonBus from '../common/CommonBus';
import FirstFivePerson from './FirstFivePerson';
import BBDLineBar from '../../../common/echarts/BBDLineBar';
import { isNotEmpty, isEmpty } from '../../../../utils/util';
import { Table } from 'antd';
import { commonRequest } from '../../common/commons';
import { reportNormal } from '../../../../services/financialPicture/baseInfo';

export default class NormalReportPrompt extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            receivable: [],         // 应收款账龄
            supplierData: [],       // 前五名供应商资料
            clientData: [],         // 前五名客户资料
            quarterOperat: [],
            busAreasData: [],
            busProdsData: [],
            suppTitle: ['采购额', '占年度采购总额比例', '供应商名'],
            clientTitle: ['销售额', '占年度销售总额比例', '客户名']
        };
    }

    componentDidMount() {
        this.reportNormalPort();
    }

    reportNormalPort = () => {
        this.setState({
            loading: true
        });
        reportNormal(commonRequest()).then(data => {
            data = data || {};
            this.setState({
                loading: true,
                quarterOperat: this.forQuarter(
                    data.busQuars
                ) || [],
                busAreasData: data.busAreas || [],
                busProdsData: data.busProds || [],
                receivable: this.receivableResetData(
                    data.receive || [],
                    data.otherreceive || []),
                supplierData: this.mergeData(data.supplier || [], true),
                clientData: this.mergeData(data.customer || [], true)
            });
        }).finally(() => {
            this.setState({
                loading: false
            });
        });
    };

    receivableResetData = (receive, other, flag) => {
        let data = [], title = '公司应收应付款项账龄情况', otherTitle = '公司其他应收款项账龄';
        data.push(this.mergeData(receive, title, flag), this.mergeData(other, otherTitle, flag));
        return data;
    };

    // 报表项目异常提示数据合并
    mergeData = (data, title, flag) => {
        if (isEmpty(data)) {
            return [];
        }
        let resetData = [], moreFortyPercent, morFouty = [];

        data.forEach(item => {
            if (isNotEmpty(item.valOccur) || isNotEmpty(item.val)) {
                resetData.push(item);
            }
            moreFortyPercent = item.key === '3年以上' && item.valOccur > 40 ? item.valOccur : '';
        });
        if (flag) {
            resetData.map(d => {
                if (d.valOccur > 40) {
                    morFouty.push({ name: d.key, value: d.valOccur });
                }
            });
        }
        return { resetData: resetData, moreFortyPercent: moreFortyPercent, morFouty: morFouty, title: title };
    }

    forQuarter = (d) => {
        let xTime = [], data = [], color = ['#2365C4', '#73CDFC', '#F99248', '#ACD598'],
            dataObj = {
                '第一季度': [],
                '第二季度': [],
                '第三季度': [],
                '第四季度': []
            };

        d.forEach(item => {
            xTime.push(item.reportyear);
            item.keyval.forEach(val => {
                if (!dataObj[val.key]) {
                    dataObj[val.key] = [];
                }
                dataObj[val.key].push(val.valOccur);
            });
        });
        for (let key in dataObj) {
            if (!dataObj[key].every(d => isEmpty(d))) { // 都不为0
                data.push({ name: key + '占比', data: dataObj[key] });
            }
        }

        return {
            color: color,
            grid: {
                top: 45,
                left: '2%',
                right: '2%',
                bottom: '3%'
            },
            legend: {
                show: true
            },
            category: xTime,
            barMaxWidth: 24,
            barGap: 0,
            barData: data
        };
    };

    columnsData = (letTitle, three, four) => {
        return [
            {
                title: four ? four : '账龄',
                dataIndex: 'key'
            },
            {
                title: letTitle ? letTitle : '期末余额',
                dataIndex: 'val'
            },
            {
                title: three ? three : '占应收账款比例',
                dataIndex: 'valOccur',
                render: text => text === null && text === '--' ? '' : text + '%'
            }
        ];
    };

    render() {
        const {
            receivable, quarterOperat, busAreasData, busProdsData,
            supplierData, clientData, suppTitle, clientTitle, loading
        } = this.state;
        return (
            <div>
                <GroupBox id="quarter-business" title="季度营业情况">
                    {
                        isNotEmpty(quarterOperat.barData) ?
                            <div className={style.quarter}>
                                <BBDLineBar option={quarterOperat} />
                            </div> : <NoData />
                    }
                </GroupBox>
                <GroupBox id="income-region" title="收入地区结构">
                    <CommonBus data={busAreasData} title={true} />
                </GroupBox>
                <GroupBox id="sales-product" title="销售产品结构">
                    <CommonBus data={busProdsData} />
                </GroupBox>
                <GroupBox id="normal-report-prompt" title="报表项目异常提示">
                    <div className={style.normalReportPrompt}>
                        {
                            receivable && receivable.map(item => (
                                <div key={item.title}>
                                    <div className="sub-title">{item.title}</div>
                                    <div className="margin-bottom-10">
                                        {
                                            item.moreFortyPercent ?
                                                <NormalReportTip proportion={item.moreFortyPercent} />
                                                : ''
                                        }
                                    </div>
                                    <Table
                                        pagination={false}
                                        bordered
                                        loading={loading}
                                        rowKey="key"
                                        dataSource={item.resetData}
                                        columns={this.columnsData()}
                                    />
                                </div>
                            ))
                        }
                        <FirstFivePerson
                            title={'前五名供应商资料'}
                            data={supplierData.resetData}
                            morFouty={supplierData.morFouty}
                            column={this.columnsData(...suppTitle)}
                            subTitle={'供应商'}
                        />
                        <FirstFivePerson
                            title={'前五大客户资料'}
                            data={clientData.resetData}
                            morFouty={clientData.morFouty}
                            column={this.columnsData(...clientTitle)}
                            subTitle={'客户'}
                        />
                    </div>
                </GroupBox>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/baseInfo/financial/NormalReportPrompt.jsx